var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Incidències a l'aula")]),_c('AddTicket'),_c('UserTicketsTable',{staticStyle:{"margin-top":"2%"},attrs:{"classroom":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }